import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {
  Checkmark as CheckmarkIcon,
  Minus as MinusIcon,
} from '../icons/Icons.jsx';
import styles from './Checkbox.scss';

const CheckboxIcon = ({
  checked,
  indeterminate,
}) => (
  <i className={classnames(styles.icon, { [styles.indeterminate]: indeterminate })}>
    {indeterminate ? <MinusIcon /> : checked ? <CheckmarkIcon /> : null}
  </i>
);

CheckboxIcon.defaultProps = {
  checked: false,
  indeterminate: false,
};

CheckboxIcon.propTypes = {
  checked: PropTypes.bool,
  indeterminate: PropTypes.bool,
};

export default CheckboxIcon;